import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8dd69a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-form-control__label"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode()
const _hoisted_3 = { class: "app-form-control__content" }
const _hoisted_4 = {
  key: 1,
  class: "app-form-control__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-form-control", [{'is-error': _ctx.errorMessage.length}, _ctx.controlClass]])
  }, [
    (_ctx.label.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
          _hoisted_2,
          _renderSlot(_ctx.$slots, "label-append", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (_ctx.errorMessage.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$localize(_ctx.errorMessage)), 1))
      : _createCommentVNode("", true)
  ], 2))
}